import React, { useEffect, useState } from "react";


import { Card, CardBody, Col, Container, Row, InputGroup } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import { AvForm } from "availity-reactstrap-validation";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import styled from "styled-components";
import {
  getCabinetLimits,
  getCabinetLimitsTotal,
  setCabinetLimitsTotal,
} from "../../../store/warehouse/actions";
import RemoteTable from "../../../components/Common/RemoteTable";
import ModifiedMetaTags from "../../../components/ModifiedMetaTags";
import CabinetLimitsBreadcrumbs from "./common/CabinetLimitsBreadcrumbs";
import CustomMultipleDateRange from "../../../components/CustomMultipleDateRange/CustomMultipleDateRange"

const CabinetLimits = props => {

  const [cabinetID, setCabinetID] = useState(null);
  const [dateFilter, setDateFilter] = useState({
    start_date: new Date(new Date().getFullYear(), new Date().getMonth(), 2).toISOString().split('T')[0],
    end_date: new Date().toISOString().split('T')[0],
  })

  useEffect(() => {
    props.getCabinetLimits({
      ...props.data,
      date_gte: dateFilter.start_date,
      date_lte: dateFilter.end_date
    });
  }, [])

  const handleTableChange = data => {
    props.getCabinetLimits({
      ...props.data,
      ...data,
      date_gte: dateFilter.start_date,
      date_lte: dateFilter.end_date
    });
  };

  const handleChangeFilterDate = (date) => {
    if (cabinetID != null) {
      props.getCabinetLimits({
        ...props.data,
        page: 1,
        cabinet_id: cabinetID,
        date_gte: date.start_date,
        date_lte: date.end_date
      });
      props.getCabinetLimitsTotal({
        cabinet_id: cabinetID,
        date_gte: dateFilter.start_date,
        date_lte: dateFilter.end_date
      })
      setDateFilter({
        start_date: date.start_date,
        end_date: date.end_date,
      })
    } else {
      props.getCabinetLimits({
        ...props.data,
        page: 1,
        date_gte: date.start_date,
        date_lte: date.end_date
      });
      setDateFilter({
        start_date: date.start_date,
        end_date: date.end_date,
      })
    }
  }

  const handleSelectID = (cabinet_id) => {
    if (cabinet_id) {
      setCabinetID(cabinet_id);
      props.getCabinetLimits({
        ...props.data,
        cabinet_id: cabinet_id,
        page: 1,
        date_gte: dateFilter.start_date,
        date_lte: dateFilter.end_date
      });
      props.getCabinetLimitsTotal({
        cabinet_id: cabinet_id,
        date_gte: dateFilter.start_date,
        date_lte: dateFilter.end_date
      })
    } else {
      setCabinetID(null);
      props.getCabinetLimits({
        ...props.data,
        page: 1,
        cabinet_id: '',
        date_gte: dateFilter.start_date,
        date_lte: dateFilter.end_date
      });
    }
  }

  const sumFormatter = (cell, row, label) => {
    return (
      <span>
        ${row[label]}
      </span>
    );
  };

  const dateFormatter = (cell, row, label) => {
    return (
      <span>
        {row[label]}
      </span>
    );
  };

  const nameFormatterWithCustomNames = (cell, row, label) => {
    if (cabinetID) {
      return (
        <span>
          {row[label] || "N\\A"}
        </span>
      );
    } else {
      return (
        <NameLink onClick={e => handleSelectID(row['cabinet_id'])}>
          {row[label] || "N\\A"}
        </NameLink>
      );
    }

  };

  const onClickRow = (e, row, type) => {

  };

  const columns = [
    {
      dataField: "cabinet_name",
      text: "Cabinet name",
      sort: true,
      formatter: (cell, row) => nameFormatterWithCustomNames(cell, row, "cabinet_name"),
    },
    {
      dataField: "cabinet_id",
      text: "Cabinet ID",
      sort: true,
      formatter: (cell, row) => nameFormatterWithCustomNames(cell, row, "cabinet_id"),
    },
    {
      dataField: "date",
      text: "Date",
      sort: true,
      formatter: (cell, row) => dateFormatter(cell, row, "date"),
    },
    {
      dataField: "limit",
      text: "Limit",
      sort: true,
      formatter: (cell, row) => sumFormatter(cell, row, "limit"),
    },
    {
      dataField: "difference",
      text: "Difference",
      sort: true,
      formatter: (cell, row) => sumFormatter(cell, row, "difference"),
    },
    {
      dataField: "balance_remaining",
      text: "Balance remaining",
      sort: true,
      formatter: (cell, row) => sumFormatter(cell, row, "balance_remaining"),
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <ModifiedMetaTags title="Cabinet Limits | Mobihunter" />
        <Container fluid>
          <Breadcrumbs
            title="Dashboard"
            breadcrumbItem="Cabinet Limits"
            link="/dashboard"
          />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <RemoteTable
                    onTableChange={handleTableChange}
                    columns={columns}
                    data={props.data}
                    loading={props.loading}
                    breadcrumbComponent={<>
                      <CabinetLimitsBreadcrumbs
                        data={cabinetID}
                        onClick={() => handleSelectID(null)}
                      />
                    </>}
                    total_info={cabinetID !== null && props.data?.count > 0 && !props.loading}
                    children_total={<>
                      <Row className="mt-3 mb-3">
                        <Col sm={12}>
                          <TotalObject>
                            Total for the period: <span className="fade-in-custom-animate-1s">{props.cabinetLimitsTotal.total_limit}$</span>
                          </TotalObject>
                        </Col>
                        <Col sm={12}>
                          <TotalObject>
                            Difference: <span className="fade-in-custom-animate-1s">{props.cabinetLimitsTotal.total_difference}$</span>
                          </TotalObject>
                        </Col>
                      </Row>
                    </>}
                  >
                    <CalendarFilter>
                      <AvForm>
                        <PickerStyled
                          style={{
                            width: "190px",
                          }}
                        >
                          <CustomMultipleDateRange
                            value={dateFilter}
                            placeholder="Select date..."
                            name={`cabinet-limits-month-picker`}
                            datePickerType={"round"}
                            errorText="Date is required!"
                            className="form-control d-block"
                            onChange={date =>
                              handleChangeFilterDate(date)
                            }
                            monthTextFormat
                          />
                        </PickerStyled>
                      </AvForm>
                    </CalendarFilter>
                  </RemoteTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

const CalendarFilter = styled.div`
    justify-content: end;
    display: flex;
`

const PickerStyled = styled(InputGroup)`
  /* max-width: ${({ customwidth }) => `${customwidth || "190px"}`}; */
  margin-right: 8px;
  margin-bottom: 5px;
  flex-direction: column;

  p {
    margin-bottom: 6px;
  }

  input {
    width: 100% !important;
    font-size: 12px;
    background: #fff !important;
  }
`;

const TotalObject = styled.div`
  font-size: 14px;

  span {
    font-weight: 500;
  }
`

const NameLink = styled.div`
  transition-duration: 0.1s;

  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

CabinetLimits.propTypes = {
  data: PropTypes.any,
  cabinetLimitsTotal: PropTypes.any,
  loading: PropTypes.bool,
  history: PropTypes.any,
  permissions: PropTypes.any,
  getCabinetLimits: PropTypes.func,
  getCabinetLimitsTotal: PropTypes.func,
  setCabinetLimitsTotal: PropTypes.func,
};

const mapStateToProps = state => ({
  data: state.Warehouse.cabinetLimitsData,
  cabinetLimitsTotal: state.Warehouse.cabinetLimitsTotal,
  loading: state.Warehouse.cabinetLimitsLoading,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getCabinetLimits,
  getCabinetLimitsTotal,
  setCabinetLimitsTotal,
})(CabinetLimits);
